module.exports = __webpack_public_path__ + "static/media/Forest.54fa04d3.svg";